<template >
<div>

  <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-50 z-50" v-if="addbook_modal">
    <div class="bg-white rounded-xl w-1/5">
      <div class="flex flex-col items-start p-4">
        <div class="flex items-center w-full">
          <div class="text-gray-900 font-medium text-lg">Add Book</div>
          <svg v-on:click="close_book_modal" class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>
        <br>
        <hr>
        
        <input class="appearance-none block w-full bg-gray-100 text-gray-700 border rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                        id="grid-first-name" 
                                        type="text" 
                                        v-model="modal_bookcode"
                                        v-on:keyup.enter="onEnter"
                                        autocomplete="off"
                                        ref="bookInput"
                                        placeholder="Book code e.g WELCOME">
                              

        <div class="ml-auto">
          <button v-on:click="save_addbook" class="bg-blue-500 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-xl">
            Add
          </button>
        
        </div>
      </div>
    </div>
  </div>

  <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-50 z-50" v-if="my_account_modal">
    <div class="bg-white rounded-xl w-[95%] max-w-4xl p-8">
      <div class="flex flex-col items-start">
        <div class="flex items-center w-full mb-4">
          <div class="text-gray-900 font-medium text-xl">My Account</div>
          <svg v-on:click="close_myaccount_modal" class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>
        <hr class="w-full mb-4">
        
        <p class="font-bold">
          Corporate Email:
          <span class="font-normal"
            v-if="corporate_email">
            {{ corporate_email }}
            <button v-if="corporate_email != 'Loading...'"
              class="text-sm text-orange font-semibold hover:text-gray rounded"
              @click="addEmail('Corporate','edit')">
              <small><i class="fa-regular fa-pen text-md text-orange-600 hover:text-orange-800 transition-colors duration-200" title="Update"></i></small>
            </button>
          </span>
          <button v-else 
            class="ml-1 bg-green-500 px-4 text-sm text-white font-semibold hover:bg-green-600 rounded" 
            v-on:click="addEmail('Corporate','add')">+ <small>ADD</small></button>
        </p>

        <p class="font-bold">
          Personal Email:
          <span class="font-normal"
            v-if="personal_email">
            {{ personal_email }}
            <button v-if="personal_email != 'Loading...'"
              class="text-sm text-orange font-semibold hover:text-gray rounded"
              @click="addEmail('Personal','edit')">
              <small><i class="fa-regular fa-pen text-md text-orange-600 hover:text-orange-800 transition-colors duration-200" title="Update"></i></small>
            </button>
          </span>
          <button v-else 
            class="ml-1 bg-green-500 px-4 text-sm text-white font-semibold hover:bg-green-600 rounded" 
            v-on:click="addEmail('Personal','add')">+ <small>ADD</small></button>
        </p>

        <p class="mt-6 p-4 bg-yellow-100 text-yellow-800 text-sm rounded-md border border-yellow-300">
          <strong>Note:</strong> Email is classified as <em>corporate</em> if its domain (e.g. @gmail.com) matches one from our registered list. Otherwise, it will be considered a <em>personal</em> email.
        </p>

      </div>
    </div>
  </div>

  <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-0 z-50" v-if="email_entry_modal">
    <div class="bg-white rounded-xl w-[95%] max-w-4xl p-8">
      <div class="flex flex-col items-start">
        <div class="flex items-center w-full mb-4" v-if="!email_otp_sent">
          <div class="text-gray-900 font-medium text-xl">{{email_modal_title}} Email Address 
            <span ref="emailEntryType" class="inline-block transition-opacity duration-300 font-bold">
              ({{ email_entry_type }})
            </span>
          </div>
          <svg v-on:click="closeaddEmail()" class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>

        <div class="flex items-center w-full mb-4" v-else>
          <div class="text-gray-900 font-medium text-xl">
            One-time Password sent to <strong>{{ email_entry_sent }}</strong>
          </div>
          <svg v-on:click="closeotpemail()" class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>
        <hr class="w-full mb-4">
        
        <p class="mt-2 p-4 bg-yellow-100 text-yellow-800 text-sm rounded-md border border-yellow-300" v-if="!email_otp_sent">
          Email is classified as <em>corporate</em> if its domain (e.g. @gmail.com) matches one from our registered list. Otherwise, it will be considered a <em>personal</em> email.
        </p>

        <p class="mt-2 p-4 bg-yellow-100 text-yellow-800 text-sm rounded-md border border-yellow-300 w-full" v-else>
          After confirming, your <strong>{{ email_entry_type.toLowerCase() }}</strong> email will be updated to <strong>{{ email_entry_sent }}</strong>. Your synced books will be cleared, and you’ll be logged out automatically.
        </p>  

        <div class="w-full mt-4" v-if="!email_otp_sent">
          <input class="appearance-none block w-full bg-gray-100 text-gray-700 border rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                        id="grid-first-name" 
                                        type="text" 
                                        v-model="email_entry_input"
                                        autocomplete="off"
                                        ref="bookInput"
                                        placeholder="sample@email.com">
        </div>

        <div class="w-full mt-4" v-else>
          <input
            class="appearance-none block w-full bg-gray-100 text-gray-700 text-center font-bold border rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="grid-first-name"
            type="text"
            v-model="otp_entry_input"
            autocomplete="off"
            placeholder="Enter OTP"
          />
          <i class="text-sm text-gray-500">
            If you didn't receive it, please check your spam folder or 
            <a class="text-blue-600 font-bold cursor-pointer hover:text-blue-800" v-on:click="resendOtptoEmail()">Resend OTP</a>. 
          </i>
        </div>                  

        <div class="ml-auto mt-5" v-if="!email_otp_sent">
          <button v-on:click="closeaddEmail()" class="bg-gray-300 hover:bg-gray-400 text-white mr-2 font-bold py-2 px-4 rounded">
            Cancel
          </button>
          <button v-on:click="proceedEmailChecker()" class="bg-green-500 hover:bg-green-800 text-white font-bold py-2 px-4 rounded">
            {{email_modal_button}}
          </button>
        </div>
        
        <div class="ml-auto mt-5" v-else>
          <button v-on:click="closeotpemail()" class="bg-gray-300 hover:bg-gray-400 text-white mr-2 font-bold py-2 px-4 rounded">
            Cancel
          </button>
          <button v-on:click="confirmEmailChangewithOTP()" class="bg-green-500 hover:bg-green-800 text-white font-bold py-2 px-4 rounded">
            Confirm
          </button>
        </div>
        

      </div>
    </div>
  </div>

  <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-0 z-50" v-if="this.email_change_type_modal">
    <div class="bg-white rounded-xl w-[95%] max-w-4xl p-8">
      <div class="flex flex-col items-start">
        <div class="flex items-center w-full mb-4">
          <div class="text-gray-900 font-medium text-xl">Email Type Mismatch Detected</div>
          <svg v-on:click="closeEmailChangeTypeModal()" class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>
        <hr class="w-full mb-4">

        <p class="mt-6 p-4 bg-red-100 text-red-800 text-sm rounded-md border border-red-300">
          <strong>Warning:</strong> Looks like the email you entered is detected as <strong>{{ temp_email_entry_type }}</strong>. If you continue, we will change the type from {{email_entry_type.toLowerCase()}} to  <strong>{{ temp_email_entry_type }}</strong>. Do you want to continue?
        </p>                      

        <div class="ml-auto mt-8">
          <button v-on:click="closeEmailChangeTypeModal()" class="bg-gray-300 hover:bg-gray-400 text-white mr-2 font-bold py-2 px-4 rounded">
            Cancel
          </button>
          <button v-on:click="finalChangeType(temp_email_entry_type)" class="bg-green-500 hover:bg-green-800 text-white font-bold py-2 px-4 rounded">
            Yes, continue
          </button>
        </div>
        
        <p class="mt-6 p-4 bg-yellow-100 text-yellow-800 text-sm rounded-md border border-yellow-300">
          <strong>How we classify email:</strong> Email is classified as <em>corporate</em> if its domain (e.g. @gmail.com) matches one from our registered list. Otherwise, it will be considered a <em>personal</em> email.
        </p>

      </div>
    </div>
  </div>


<div class="h-screen  overflow-x-hidden " ref="dragArea">
  <div class="navbar main-blue" v-if="authenticated">

        <div class="flex-1"  v-if="theme == undefined || theme == 'empty' || theme == ''">
          <a class="btn btn-ghost normal-case text-xl" v-on:click="home"><img class="object-contain h-8 inline" alt="Tap Logo" src="@/assets/tap-logo.png"><p class="text-sm inline text-gray-500">&emsp;Cloudstaff Tap</p></a>
        </div>

        <div class="flex-1" v-else>
          <a class="btn btn-ghost normal-case text-xl" v-on:click="home"><img class="object-contain h-8 inline" :src="this.theme_url + '/tapadmin/' + theme "></a>
        </div>


        <div class="flex-none">
          <div class="mr-3">
            <label tabindex="0" class="btn btn-ghost btn-circle" v-on:click="home">
              <div class="indicator">
                <i class="fa-regular fa-house object-contain h-7 inline)"></i>
              </div>
            </label>
          </div>
          <!-- FAVORITES ICON -->
          <div class="mr-3">
            <label tabindex="0" class="btn btn-ghost btn-circle" v-on:click="goToFavorites">
              <div class="indicator">
                <i class="fa-regular fa-star object-contain h-7 inline"></i>
              </div>
            </label>
          </div>
           <div class="dropdown dropdown-end mr-3" v-on:click="toggleDropdownVisibility" id="dropdown">
            <label tabindex="0" class="btn btn-ghost btn-circle" v-on:focusin="handleFocusOut">
              <div class="indicator">
                <i class="fa-regular fa-cog object-contain h-7 inline"></i>
              </div>
            </label>
            <ul tabindex="0" class="mt-3 p-2 shadow menu menu-compact dropdown-content bg-base-100 rounded-box w-52"  v-if="dropdownVisible">
              <li>
                  <a v-on:click="open_book_modal">
                    Add Book
                  </a>
              </li>
              <li>
                  <a v-on:click="settings">
                    Settings
                  </a>
              </li>
            </ul>
          </div>

          <div class="dropdown dropdown-end mr-3" v-on:click="toggleDropdownVisibility" id="dropdown">
            <label tabindex="0" class="btn btn-ghost btn-circle avatar"  v-on:focusin="handleFocusOut" >
              <ProfileAvatar v-if="is_cloudstaffer == false" :username="auth_user" size="s" bgColor="#105BE9" textColor="#FAF9F6" borderColor="#e5e7eb" style="width: 40px !important; height: 40px !important;"></ProfileAvatar>
              <div v-else-if="is_cloudstaffer == true" class="w-7 rounded-full">
                <img class="object-contain h-8 inline" :src="'https://images.cloudstaff.com/getimage/'+this.$store.getters.auth_username">
              </div>
            </label>
            <ul tabindex="0" class="mt-3 p-2 shadow menu menu-compact dropdown-content bg-base-100 rounded-box w-52"  v-if="dropdownVisible">
              <li>
                <a v-on:click="open_myaccount_modal">
                  My Account
                </a>
              </li>
              
              <li v-if="login_mode != 'MSTEAMS'">
                <a v-on:click="logout">
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
  </div>


    <div class="bubble" @mousedown="dragMouseDown" ref="draggableContainer" id="draggable-container" v-if="botleyShow">
      <div class="botley_pic" v-if="botleyTempClose == false"></div>
    </div>
    <div id="bubble-close" v-if="closeShow">
        <div id="center">
            <div id="bubble-closing" ref="dropZone">
                <div id="wo-botley-closing"  v-if="botleyTempClose == false"></div>
                <div id="w-botley-closing"  v-else-if="botleyTempClose == true"></div>
            </div>
        </div>
    </div>

    <div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-50 z-50" v-if="botleyChatBox">
  <div class="bg-white rounded-xl w-1/2">
    <div class="flex flex-col items-start p-4">
      <div class="flex items-center w-full">
      <a v-on:click="botleyChatClose"><svg class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
        </svg></a>
      </div>

  <div class="flex-1 p:2 sm:p-6 justify-between flex flex-col" style="width: 100%;">
    <div class="flex items-center py-3  w-1/3">
      <div class="relative flex items-center space-x-4">
        <div class="relative">
            <span class="absolute text-green-500 right-0 bottom-0">
              <svg width="20" height="20">
                  <circle cx="8" cy="8" r="8" fill="currentColor"></circle>
              </svg>
            </span>
        <img src="@/assets/botley.gif" alt="" class="w-10 sm:w-16 h-10 sm:h-16 rounded-full">
      </div>
      <div class="flex flex-col leading-tight">
            <div class="text-2xl mt-1 flex items-center">
              <span class="text-gray-700 mr-3">Botley</span>
            </div>
            <span class="text-lg text-gray-600">Cloudstaff Bot</span>
      </div>
    </div>
  </div>
  <div id="chatBoxMessage" class="flex flex-col space-y-4 p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch" style="height: 300px !important;">
      <div v-for="(chats, chatsKey) in botley_convo" :key="chats.id">
        <div class="chat-message" v-if="chats.caster == 'botley'" v-bind:id="'chat_ele'+chatsKey">
        <div class="flex items-end">
            <div class="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-2 items-start">
              <div><span class="px-4 py-2 rounded-lg inline-block rounded-bl-none bg-gray-300 text-gray-600 text-left"  v-html="chats.message"></span></div>
            </div>
          <img src="@/assets/botley.gif" alt="My profile" class="w-6 h-6 rounded-full order-1">
        </div>
      </div>
      <div class="chat-message" v-else-if="chats.caster == 'user'" v-bind:id="'chat_ele'+chatsKey"> 
        <div class="flex items-end justify-end">
            <div class="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-1 items-end">
              <div><span class="px-4 py-2 rounded-lg inline-block bg-blue-600 text-white ">{{chats.message}}</span></div>
            </div>
            <img :src="'https://images.cloudstaff.com/getimage/'+auth_username" alt="My profile" class="w-6 h-6 rounded-full order-2">
        </div>
      </div>
      </div>
  </div>

        <div class="border-t-2 border-gray-200 px-4 pt-4 mb-2 sm:mb-0">
            <div class="relative flex">
              
              <input type="text" placeholder="Aa" v-model="user_chat" class="w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 pl-12 bg-gray-200 rounded-md py-3">
              <div class="absolute right-0 items-center inset-y-0 hidden sm:flex">
                  <button type="button" v-on:click="botleyChatSubmit" class="inline-flex items-center justify-center rounded-lg px-4 py-3 transition duration-500 ease-in-out text-white bg-blue-500 hover:bg-blue-400 focus:outline-none">
                    <span class="font-bold">Send</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 ml-2 transform rotate-90">
                        <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                    </svg>
                  </button>
              </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</div>   
    <router-view class="flex lg:justify-center items-center sm:overflow-y-auto flex-grow main-blue overflow-x-hidden"/>
    
    <div class="py-4 px-16 footer main-blue text-base-content footer-center " v-if="authenticated">
      <div class="flex w-full px-15">
        <div class="flex-none">
          © 2022 <a href="https://www.cloudstaff.com" style="color:black;" title="Visit Cloudstaff Official Website">Cloudstaff Official Website</a>. All rights reserved.
        </div>
        <div class="grow">
        
          Version {{this.appVersion}}
          
        </div>
        <div class="flex-none">
          
          <a class="text-blue-600" v-on:click="data_consent" style="cursor: pointer;">Data Consent</a>
          &emsp;
          <a class="text-blue-600" v-on:click="gotoppolicy" style="cursor: pointer;">Privacy Policy</a>
        </div>
      </div>
    </div>
</div>
</div>

</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

   /* botley */
#bubble-close {
    position: fixed;
    z-index: 998;
    bottom: 30px;
    width: 100%;

    
}
#center {
    width: 500px;
    margin-left: 50%;

}
#bubble-closing {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    bottom: 10px;
    right: 10px;
    
    z-index: 998;
}

#wo-botley-closing{
    width: 75px;
    height: 75px;
    border-radius: 50%;
    box-shadow: 0 0px 20px rgba(0,0,0,0.19), 0 0px 6px rgba(0,0,0,0.23);
    background-image: url('./assets/botley-close.png');
    background-size: cover;
}

#w-botley-closing{
    width: 75px;
    height: 75px;
    border-radius: 50%;
box-shadow: 0 0px 20px rgba(0,0,0,0.19), 0 0px 6px rgba(0,0,0,0.23);
    background-image: url('./assets/botley-close.gif');
    background-size: cover;
}

.botley_pic{
    width: 75px;
    height: 75px;
    background-image: url('./assets/botley.gif');
    background-size: cover;
    border-radius: 50%;
    box-shadow: 0 0px 20px rgba(0,0,0,0.19), 0 0px 6px rgba(0,0,0,0.23);
}
  
  .bubble{
    width: 75px;
    height: 75px;
    position: absolute;
    cursor: pointer;
    bottom: 10px;
    right: 10px;
    
  
    z-index: 999;
  }

  @keyframes pulseAttention {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.3); }
  }

  .attention {
    animation: pulseAttention 0.5s ease-in-out 3;
  }
    
</style>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import axios from 'axios';
import ProfileAvatar from 'vue-profile-avatar';

const audiosrc = require("@/assets/chat.mp3");
export default ({
  
  name: 'App',
  
  computed:{
    ...mapGetters([
      'authenticated',
      'auth_token',
      'auth_user',
      'selected_book',
      'botley_convo',
      'auth_username',
      'is_cloudstaffer',
      'addbook_modal',
      'theme',
      'login_mode',
      'my_account_modal',
      'email_entry_modal',
      'email_entry_type',
      'my_corporate_email',
      'my_personal_email',
      'email_otp_sent',
      'email_entry_sent'
    ]),
    currentRouteName() {
        return this.$route.name;
    }
  },
  components: {
    ProfileAvatar
  },
  watch: {
    addbook_modal(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.$refs.bookInput.focus();
          });
        }
      },
  },
  data() {
          return {
              positions: {
              clientX: undefined,
              clientY: undefined,
              movementX: 0,
              movementY: 0
            },
            closeShow: false,
            botleyShow: false,
            botleyTempClose: false,
            botleyChatBox: false,
            drag: false,
            user_chat: '',
            dropdownVisible: false,
            login_mode_data: "",
            first_occurrence_index: 0,
            modal_bookcode: '',
            personal_email: this.$store.getters.my_personal_email,
            corporate_email: this.$store.getters.my_corporate_email,
            adding_email_type: '',
            email_entry_input: '',
            email_modal_title: 'Enter',
            email_modal_button: 'Proceed',
            temp_email_entry_type: '',
            email_change_type_modal: false,
            otp_entry_input: '',
            otpThrottle: false,
            throttleTimeLeft: 0,
            throttleInterval: null,
          }
  },
  mounted(){
    this.get_avatar_image();
    this.gettheme();
    this.$store.dispatch('addBookModal', false);
  },
  inject: ["moshaToast"],
  methods:{
    goToFavorites() {
      this.$router.push('/favorites');
    },
    gotoppolicy(){
      window.open('/privacy-policy', '_blank');
    },
    gettheme() {
      var bodyFormData = new FormData();
      bodyFormData.append("email", this.$store.getters.auth_user);

      axios({
          method: "post",
          url: this.baseAPIURL+"/apiv3/theme.json",
          data: bodyFormData,
          headers: {
              "auth": this.$store.getters.auth_token,
              "Content-Type": "multipart/form-data",
          },
      })
      .then(response => {
          this.$store.dispatch("updateTheme", response.data.theme[0].web_main_page_icon);
      });
    },
    
    onEnter: function() {
      this.save_addbook();
    },  

    get_avatar_image(){
      if (/@cloudstaff.com\s*$/.test(this.$store.getters.auth_user)) {
        this.$store.dispatch("setCS", true);
      } else {
        this.$store.dispatch("setCS", false);
      }
    },

    clear_messages(){
      this.$store.dispatch('unsetBotleyConvo');
    },
    async scrollFunc (element) {
            this.$scrollTo('#chat_ele'+element, 10, {
                easing: 'ease', 
                cancelable: true,
                container: '#chatBoxMessage',
            })
    }, 

    toggleDropdownVisibility(){
        if (this.dropdownVisible == true) {
          this.dropdownVisible = false;
        } else {
          this.dropdownVisible = true;
        }
    },
    handleFocusOut() {
            // do something here
          this.dropdownVisible = false;
    },
    botleyChatSubmit(){
        // this.user_chat;
        this.$store.dispatch('setBotleyConvo', {
          'caster': 'user',
          'message': this.user_chat
        });

        var url = "https://tap.cloudstaff.com/apiv2/testBotleyCommand?user="+this.$store.getters.auth_user+"&command="+this.user_chat;
        var audio = new Audio(audiosrc);

        var settings = {
                "url": url,
                "method": "GET",
                "timeout": 0,
            };

            axios(settings)
            .then((response) => {
                // console.log(response.data);  
                this.$store.dispatch('setBotleyConvo', {
                  'caster': 'botley',
                  'message': response.data
                });
                audio.play();

                setTimeout(() => {
                  this.scrollFunc(this.$store.getters.botley_convo.length-1);
                }, 100);
        })
        .catch((error) => {
          console.log(error);
          return error;
        });

        this.user_chat = '';
        setTimeout(() => {
          this.scrollFunc(this.$store.getters.botley_convo.length-1);
        }, 100);
        

    },
    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      this.drag = false;

      document.getElementById("draggable-container").addEventListener('mousedown', () => this.drag = false);
      document.getElementById("draggable-container").addEventListener('mousemove', () => this.drag = true);
      document.getElementById("draggable-container").addEventListener('mouseup', () => this.drag ? 'drag' : this.botleyChatOpen());
    
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
      
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      
      // set the element's new position:
      if (this.positions.clientY+50 > this.$refs.dragArea.clientHeight) {
        this.$refs.draggableContainer.style.top = (this.$refs.dragArea.clientHeight-80) + 'px'
      } else {
        this.$refs.draggableContainer.style.top = (this.$refs.draggableContainer.offsetTop - this.positions.movementY) + 'px'
        this.$refs.draggableContainer.style.left = (this.$refs.draggableContainer.offsetLeft - this.positions.movementX) + 'px'
      }

      this.closeShow = true;

      const domRect1 = this.$refs.draggableContainer.getBoundingClientRect();
      const domRect2 = this.$refs.dropZone.getBoundingClientRect();

      this.botleyTempClose = !(
        domRect1.top > domRect2.bottom ||
        domRect1.right < domRect2.left ||
        domRect1.bottom < domRect2.top ||
        domRect1.left > domRect2.right)
    },
    closeDragElement () {
      if (this.positions.clientX < 950) {
        this.$refs.draggableContainer.style.top = (this.$refs.draggableContainer.offsetTop - this.positions.movementY) + 'px'
        this.$refs.draggableContainer.style.left = '1%'
      } else if (this.positions.clientX > 950) {
        this.$refs.draggableContainer.style.top = (this.$refs.draggableContainer.offsetTop - this.positions.movementY) + 'px'
        this.$refs.draggableContainer.style.left = '95%'
        this.$refs.draggableContainer.style.transform = "translate(0px, 0px)";
      }

      if (this.positions.clientY+50 > this.$refs.dragArea.clientHeight) {
        this.$refs.draggableContainer.style.top = (this.$refs.dragArea.clientHeight-80) + 'px'
      }

      if (this.botleyTempClose == true) {
        this.botleyShow = false;
      }

      this.closeShow = false;
      document.onmouseup = null
      document.onmousemove = null
    },
    botley() {
        
        setTimeout(() => {
          this.scrollFunc(this.$store.getters.botley_convo.length-1);
        }, 100);
        this.botleyChatBox = true;
        this.botleyTempClose = false;
        this.botleyShow = false; //make this true if you want a draggable widget for botley
    },
    botleyChatOpen(){
      setTimeout(() => {
        this.scrollFunc(this.$store.getters.botley_convo.length-1);
      }, 100);
      this.botleyChatBox = true;
    },
    botleyChatClose(){
      this.botleyChatBox = false;
      this.botleyShow = false;  //remove this line if you want a draggable widget for botley
    },
    data_consent(){
      Swal.fire({
            html: '<p class="align-left consent-header"><strong>Data Processing Consent</strong></p><br><hr><br>'+
            '<div class="align-left">I acknowledge and understand that my Personal Data as defined by the Data Privacy Act of 2012 will be collected by Cloudstaff,'+
            'and that my Personal Data may be processed, stored, updated or disclosed by Cloudstaff for the following purpose:'+
            '<br><br>'+
            '<table class="align-justify">'+
            '<tr><td>&#8226;</td><td class="ml-2"> To be able to open an account in CS Tap and keep the account active;</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To conduct research and analysis (through survey or polls) in order to improve customer/ guest experience/ satisfaction;</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To respond to specific complaints, inquiries, requests, or to provide requested information;</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To provide customer care activities, monitor our quality and security, and provide services timely and efficiently;</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To comply with legal and regulatory requirements or obligations and,</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To perform such other processing or disclosure that may be required under law or regulations.</td></tr>'+
            '<tr><td>&#8226;</td><td class="ml-2"> To keep records of historical developments of the CS Tap Web</td></tr>'+
            '</table><br><br>',
            type: "info",
            allowOutsideClick: true,
            allowEscapeKey: true,
            showCancelButton: true,
            showConfirmButton: false,
            buttonsStyling: false,
            reverseButtons: true,
            customClass: {
                    popup: 'w-[50%]',
                    cancelButton: 'px-6 py-2 bg-white-100 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-gray-400 hover:bg-gray-100',
            },
            cancelButtonClass: 'px-6 py-2 bg-white-100 rounded-lg hover:bg-blue-900 mx-2 my-2 border border-gray-400 hover:bg-gray-100 inline right-5 bottom-2 absolute',
            cancelButtonColor: '#FFFFFF',
            cancelButtonText:
            'Close',
    })
    },
    checkAndCloseDropDown(e){
      let targetEl = e.currentTarget;
      if (targetEl && targetEl.matches(':focus')) {
        setTimeout(function(){
          targetEl.blur();
        }, 0);
      }
    },

    logout (){
      var data = {
        "auth": this.$store.getters.auth_token,
        "email": this.$store.getters.auth_user,
      }

      var logout_setting = {
                            "url": this.baseAPIURL+"/apiv3/logout.json",
                            "method": "POST",
                            "headers": {
                              "auth": this.$store.getters.auth_token,
                            },
                            "data": data
                        };

      axios(logout_setting)
      .then((response) => {
          // console.log(response.data);  
            if (response.data.status == "success") {
                this.$store.dispatch('logoutUser');
                this.$router.push('/');
                this.moshaToast("You have logged-out!", { type: "success" });
            }
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
    },
    settings(){
      this.$router.push("/settings");   
    },

    open_book_modal(){
      this.$store.dispatch('addBookModal', true);
    },
    close_book_modal(){
      this.$store.dispatch('addBookModal', false);
    },


    display_emails() {
      this.personal_email = this.my_personal_email;
      this.corporate_email = this.my_corporate_email;
    },

    open_myaccount_modal(){

      this.personal_email = "Loading...";
      this.corporate_email = "Loading...";

      axios({
      method: "post",
      url: this.baseAPIURL+"/apiv3/getemailinfo.json",
      headers: {
          "auth": this.$store.getters.auth_token,
          "Content-Type": "multipart/form-data",
      },
      })
      .then(response => {
        //handle succes
        if (response.data.data.email_fixed == 0) { // initial setup
          this.fix_email(this.$store.getters.auth_user);
        } else {
          this.$store.dispatch('myPersonalEmail', response.data.data.personal_email);
          this.$store.dispatch('myCorporateEmail', response.data.data.corporate_email);
        }

      }).catch(error => {
          console.log("Error: "+ error);
          this.moshaToast("Error!", { type: "danger" });
      });
      
      this.$store.dispatch('myAccountModal', true);

      setTimeout(() => {
        this.display_emails();
      }, 2000);
    },

    fix_email(current_email){
      var data = {
        "email": current_email,
      }
      
      axios({
      method: "post",
      url: this.baseAPIURL+"/apiv3/emailchecker.json",
      headers: {
          "auth": this.$store.getters.auth_token,
          "Content-Type": "multipart/form-data",
      },
      data: data,
      })
      .then(response => {
        
        if (response.data.data.type == "corporate") {
          var insertType = "work";
        } else {
          insertType = "personal";
        }

        var dataSorter = {
            "email": current_email,
            "type": insertType,
        }

        axios({
        method: "post",
        url: this.baseAPIURL+"/apiv3/emailsorter.json",
        headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "multipart/form-data",
        },
        data: dataSorter,
        })
        .then(response => {
            console.log(response.data.message);

            if (insertType == "work") {
              this.$store.dispatch('myCorporateEmail', current_email);
            } else {
              this.$store.dispatch('myPersonalEmail', current_email);
            }
        });
      }).catch(error => {
          console.log("Error: "+ error);
          this.moshaToast("Error!", { type: "danger" });
      });
    },

    addEmail(type, procedure){
      if (procedure == "edit") {
        this.adding_email_type = type;
        this.email_entry_input = (type == "Corporate") ? this.my_corporate_email : this.my_personal_email;
        this.email_modal_title = 'Update';
        this.email_modal_button =  'Proceed Update';

      } else {
        this.adding_email_type = "";
        this.email_entry_input = "";
        this.email_modal_title = 'Enter';
        this.email_modal_button =  'Proceed';
      }

      this.$store.dispatch('emailEntryType', type);
      this.$store.dispatch('emailEntryModal', true);
    },
    
    closeaddEmail(){
      this.$store.dispatch('emailEntryType', "");
      this.$store.dispatch('emailEntryModal', false);
    },

    closeotpemail(){
      this.$store.dispatch('emailEntrySent', "");
      this.$store.dispatch('emailOTPSent', false);
    },

    close_myaccount_modal(){
      this.$store.dispatch('myAccountModal', false);
    },
    
    openEmailChangeTypeModal(){
      this.email_change_type_modal = true;
    },
    
    closeEmailChangeTypeModal(){
      this.email_change_type_modal = false;
    },

    confirmEmailChangewithOTP() {
      this.otp_entry_input = this.otp_entry_input.trim();

      if (this.otp_entry_input == null || this.otp_entry_input.trim() === '') {
        this.moshaToast("Please enter a proper OTP!", { type: "warning" });
      } else {

        const requestData = {
          email: this.$store.getters.email_entry_sent,
          code: this.otp_entry_input
        };

        axios({
          method: "post",
          url: this.baseAPIURL+"/apiv3/myaccountemailconfirmotp.json",
          data: requestData,
          headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "application/json",
          },
        })
        .then(response => {
          //handle success
          console.log(response.data);
          if (response.data.status == "success") {

            const requestDataUpdateEmail = {
              new_email: this.$store.getters.email_entry_sent,
              type: this.$store.getters.email_entry_type.toLowerCase()
            };
            
            axios({
              method: "post",
              url: this.baseAPIURL+"/apiv3/updateemailaccount.json",
              data: requestDataUpdateEmail,
              headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "application/json",
              },
            })
            .then(response => {
              console.log(response.data);
              if (response.data.status == "success") {
                if (this.$store.getters.email_entry_type.toLowerCase() == "corporate") {
                  this.$store.dispatch('myCorporateEmail', this.$store.getters.email_entry_sent);
                  this.corporate_email = this.$store.getters.email_entry_sent;
                } else {
                  this.$store.dispatch('myPersonalEmail', this.$store.getters.email_entry_sent);
                  this.personal_email = this.$store.getters.email_entry_sent;
                }
                
                this.moshaToast(this.$store.getters.email_entry_type+" email updated successfully!", { type: "success" });

                this.closeotpemail();
                this.closeEmailChangeTypeModal();
                this.closeaddEmail();
                
                this.$store.dispatch('emailEntrySent', "");
                this.$store.dispatch('emailOTPSent', false);

                // Notify user about upcoming logout
                
                setTimeout(() => {
                this.$moshaToast("You will be logged out in 3 seconds...", { type: "warning" });
                }, 1000);

                // Add a 2-second delay before logging out
                setTimeout(() => {
                  this.$store.dispatch('logoutUser');
                  this.$router.push('/');
                  this.$router.push('/');
                  this.$moshaToast("You have been logged out!", { type: "success" });
                }, 4000);


              } else {
                this.moshaToast("Error updating email!", { type: "danger" });
              }
            });
          } else if (response.data.status == "error") {
            this.moshaToast("OTP doesn't match. Please verify and retry.", { type: "danger" });
          } else {
            this.moshaToast("Error updating email!", { type: "danger" });
          }
        }).catch(error => {
          console.log("Error: "+ error);
          this.moshaToast("Error confirming email change!", { type: "danger" });
        });
      }
    },

    resendOtptoEmail() {
      if (this.otpThrottle) {
        this.moshaToast(`Please wait ${this.throttleTimeLeft}s before resending the OTP.`, { type: "warning" });
        return;
      }

      this.otpThrottle = true;
      this.throttleTimeLeft = 30; // ⏳ throttle duration in seconds

      // Start countdown timer
      this.throttleInterval = setInterval(() => {
        this.throttleTimeLeft--;
        if (this.throttleTimeLeft <= 0) {
          clearInterval(this.throttleInterval);
          this.otpThrottle = false;
          this.throttleInterval = null;
        }
      }, 1000);

      const requestData = {
        email: this.$store.getters.email_entry_sent
      };

      axios({
        method: "post",
        url: this.baseAPIURL + "/apiv3/myaccountemailsendotp.json",
        data: requestData,
        headers: {
          "auth": this.$store.getters.auth_token,
          "Content-Type": "application/json",
        },
      })
      .then(response => {
        console.log(response.data);
        this.$store.dispatch('emailOTPSent', true);
        this.moshaToast("A new OTP has been sent to: " + this.$store.getters.email_entry_sent, { type: "success" });
      }).catch(error => {
        console.log("Error: " + error);
        this.moshaToast("Error sending OTP!", { type: "danger" });
      });
    },

    sendOtptoEmail() {
      this.otp_entry_input = "";
      var email = this.$store.getters.email_entry_sent;

      console.log("sendOtptoEmail", email);

      if (email == null || email.trim() === '' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
        this.moshaToast("Please enter a proper email!", { type: "warning" });
      } else {

        const requestData = {
          email: email
        };

        axios({
          method: "post",
          url: this.baseAPIURL+"/apiv3/myaccountemailsendotp.json",
          data: requestData,
          headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "application/json",
          },
        })
        .then(response => {
          //handle success
          console.log(response.data);
          this.$store.dispatch('emailOTPSent', true);
        }).catch(error => {
          console.log("Error: "+ error);
          this.moshaToast("Error sending OTP!", { type: "danger" });
        });
      }
    },

    finalChangeType(email_type) {
      console.log("finalChangeType", this.temp_email_entry_type);
      var emailfix = email_type.charAt(0).toUpperCase() + email_type.slice(1).toLowerCase();
      
      this.sendOtptoEmail();

      this.$store.dispatch('emailEntryType', emailfix);

      setTimeout(() => {
        this.closeEmailChangeTypeModal();
      }, 500); // 500 milliseconds (0.5 second) delay

    },

    proceedEmailChecker(){
      this.email_entry_input = this.email_entry_input.trim();

      if (
        this.email_entry_input === this.my_personal_email ||
        this.email_entry_input === this.my_corporate_email
      ) {
        this.moshaToast("This email already exist in your account.", { type: "warning" });
      } else {
        if (
          this.email_entry_input == null ||
          this.email_entry_input.trim() === '' ||
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email_entry_input.trim())
        ){
          this.moshaToast("Please enter a proper email!", { type: "warning" });
        } else {

          const requestData = {
            email: this.email_entry_input
          };

          axios({
            method: "post",
            url: this.baseAPIURL+"/apiv3/emailchecker.json",
            data: requestData,
            headers: {
              "auth": this.$store.getters.auth_token,
              "Content-Type": "application/json",
            },
          })
          .then(response => {
              //handle success

            if (response.data.data.usersExist == 'yes') {
              this.moshaToast(`${this.email_entry_input} is already associated with an account. Please log in instead.`, { type: "danger" });
            } else {
              if ( response.data.data.type == this.email_entry_type.toLowerCase() ) {
                //SEND OTP
                
                this.$store.dispatch('emailEntrySent', this.email_entry_input);
                this.sendOtptoEmail();

              } else {
                
                this.$store.dispatch('emailEntrySent', this.email_entry_input);
                this.confirmChangeEmailTypeModal(response.data.data.type);
              }
            }

          }).catch(error => {
            console.log("Error: "+ error);
            this.moshaToast("Email cannot be added!", { type: "danger" });
          });
        }
      }
    },

    confirmChangeEmailTypeModal(email_entry_type) {
      console.log("confirmChangeEmailTypeModal", email_entry_type);
      this.temp_email_entry_type = email_entry_type;
      this.openEmailChangeTypeModal();
    },

    animateAttention(el) {
      if (el) {
        el.classList.add('attention'); // or 'vibrate'
        setTimeout(() => {
          el.classList.remove('attention'); // or 'vibrate'
        }, 1500);
      }
    },

    save_addbook(){
      this.modal_bookcode = this.modal_bookcode.trim();
      
      if (this.modal_bookcode == null || this.modal_bookcode.trim() === ''){
        this.moshaToast("Please enter a proper book code!", { type: "warning" });
      } else {
        if (this.$store.getters.books.includes(this.modal_bookcode.toUpperCase())) {
          if (!this.$store.getters.active_books.includes(this.modal_bookcode.toUpperCase())) {
                  var message = this.modal_bookcode.toUpperCase()+" is already added but disabled on settings page.";
            } else {
              message = this.modal_bookcode.toUpperCase()+" is already added.";
            }

            this.moshaToast(message, { type: "warning" });
                          
        } else {
            var bodyFormData = new FormData();
            bodyFormData.append("code", this.modal_bookcode);

            axios({
                method: "post",
                url: this.baseAPIURL+"/apiv3/getbook.json",
                data: bodyFormData,
                headers: {
                    "auth": this.$store.getters.auth_token,
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
              var responseData = JSON.parse(JSON.stringify(response.data.books));

              this.$store.dispatch('setActiveBooks', responseData[0].code);
              this.$store.dispatch('addBook', responseData[0].code);

              this.moshaToast(responseData[0].code+" added successfully!", { type: "success" });
              this.$store.dispatch('setBookAndDesc', {"title":response.data.books[0].code, "desc":response.data.books[0].description});

            }).catch(error => {
                console.log("Error: "+ error);
                this.moshaToast("No access to book!", { type: "danger" });
            });
        }              
      }
      this.modal_bookcode = "";           
    },
  
    handle_error () {
        localStorage.clear();
        this.moshaToast("Your session has expired. Please log in again.", { type: "warning" });
        // Add a delay before reloading the page
        setTimeout(() => {
          location.reload();
        }, 3000); // 5000 milliseconds = 5 seconds
    },
    async home(){
                  await new Promise(resolve => {
                        this.gettheme();
                        setTimeout(() => {

                          this.$store.dispatch('setLoading', true);

                          for (var i=0; i<this.$store.getters.books.length; i++) {
                            if (this.$store.getters.active_books.includes(this.$store.getters.books[i])) {
                                this.first_occurrence_index = i;
                                break;
                            }
                          }
                      
                          this.$store.dispatch('activeBook', this.$store.getters.books[this.first_occurrence_index]);
                          this.$store.dispatch('unsetActiveTile');

                          var bodyFormData = new FormData();
                          bodyFormData.append("code", this.$store.getters.books[this.first_occurrence_index]);

                            axios({
                                method: "post",
                                url: this.baseAPIURL+"/apiv3/getbook.json",
                                data: bodyFormData,
                                headers: {
                                    "auth": this.$store.getters.auth_token,
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                            .then(response => {
                                //handle success
                                
                                    this.$store.dispatch('unsetTiles');
                                    this.$store.dispatch('activeBookDesc', response.data.books[0].description);
                                    this.$store.dispatch('setPages', response.data.books[0].pages);

                                    response.data.books[0].pages.map( (page_item, index) => {
                                          if (index === 0) {   
                                                    this.$store.dispatch('activePage', page_item.title);
                                          }
                                    });
                                    this.$store.dispatch('setLoading', false);
                                    this.$router.push('/dashboard');
                            }).catch( error => {
                              // Handle errors
                              if (error.response) {
                                // The request was made, and the server responded with a non-2xx status code
                                if (error.response.status === 502 || error.response.status === 500) {
                                  // Handle specific HTTP status codes (502 or 500) here
                                  this.handle_error();
                                } else {
                                  this.handle_error();
                                }
                              } else if (error.request) {
                                this.handle_error();
                              } else {
                                this.handle_error();
                              }
                            });
                          
                            resolve(1);
                        }, 1);
                  });
                  
              // }
    }
  }
})

</script>

